import React from 'react';
import './RestaurantInfo.css';

const RestaurantInfo = () => {
  return (
    <div className="restaurant-info wide-restaurant-info">
      <div className="restaurant-content">
        <h2 className="restaurant-name">Pierchic</h2>
        <p className="restaurant-description">Award-winning Italian cuisine on our private pier, a world away from the city.</p>
        <div className="map-container wide-map-container">
          <button className="enlarge-map">Увеличить карту</button>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.238722352548!2d55.18556031501047!3d25.141169983933885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6834bdfa3c5d%3A0x2e1a5f1b3b3e1b1a!2sAl%20Qasr%20Hotel!5e0!3m2!1sen!2sae!4v1623345678901!5m2!1sen!2sae" 
            width="100%" 
            height="260" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy"
            title="Restaurant location"
          ></iframe>
        </div>
        <div className="map-address">Al Qasr Hotel, Al Sufouh Road, Dubai</div>
      </div>
    </div>
  );
};

export default RestaurantInfo; 